import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '$/assets/logo-inverted.svg';
import './Login.scss';
import LoginForm from './LoginForm';

interface ILoginProps {
  welcomeMessage: string;
  emailPlaceholder: string;
  passwordPlaceholder: string;
  isLoading: boolean;
  email: string;
  onEmailChange: React.ChangeEventHandler;
  password: string;
  onPasswordChange: React.ChangeEventHandler;
  onSubmit: React.FormEventHandler;
  errorText?: string;
}

const Login: React.FC<ILoginProps> = props => {
  const { welcomeMessage } = props;

  return (
    <div className="loginPage">
      <div className="content_wrap">
        <div className="logo_welcome">
          <Logo />
          {welcomeMessage}
        </div>
        <LoginForm {...props} />
        <div className="forgot">
          <Link to="/forgot-password">Forgot Password?</Link>
        </div>
      </div>
      <div className="copy_foot">&copy; {new Date().getFullYear()} Bixby Research and Analytics LLC</div>
    </div>
  );
};
export default Login;
